<template>
  <div class="loading" v-show="show">
    <img src="../../assets/img/loading.gif" alt="" srcset="">
  </div>
</template>

<script>
import { getGlobalEvent } from '../../lib/eventEmitter';
const eventEmitter = getGlobalEvent()

export default {
  data() {
    return {
      show: false,
    }
  },
  methods: {
    close() {
      this.show = false
    }
  },
  mounted() {
    eventEmitter.on('loading', ifShow => {
      this.show = ifShow
    })
  },
}
</script>

<style lang="scss" scoped>
  .loading {
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 999999;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.3);
    color: #fff;
    font-size: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>


// WEBPACK FOOTER //
// src/components/Loading/Loading.vue